<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title1" id="C3">General Techniques</h1>
<p class="intro">Before you begin working on a piece, it is important to familiarise yourself with all the techniques you may require to create your chosen project. Start by taking the time to read through this section, which includes handy tips on getting started as well as advice on how to neatly finish your macraweave masterpieces.</p>
<h2 class="subhead1" id="S1">Mounting Techniques</h2>
<p class="noindent">It is very important to have a firm tension when working on the macramé structure and weaving element of your projects, so set yourself up with the correct equipment to mount your projects.</p>
<p class="noindent1">For small projects such as the jewellery and key rings, we recommend investing in a project board. This is printed with a grid and cords, and hardware can be attached to it using T-pins. Alternatively, a flat surface and adhesive tape will suffice.</p>
<p class="noindent1">For most of the projects, we have used a clothes rack as a work station. You can use S-hooks to secure a ring or a piece of dowel to the rack. Alternatively, you can simply use rope to tie them on to your rack.</p>
<h2 class="subhead1">Wrapping a Ring</h2>
<p class="noindent">Secure one end of your rope length onto the ring with craft glue or a hot glue gun, pressing it down firmly. Taking the long end of the cord through the ring, wrap the rope around the ring to cover it completely leaving just enough space to secure the cord end to the ring, again with glue, once trimmed.</p>
<p class="image-center"><img alt="" src="images/P12-1.jpg"/></p>
<h2 class="subhead1">Fraying</h2>
<p class="noindent">This is a finishing technique where the rope is unravelled by separating each strand into its constituent parts to create a fringe, or for a tassel.</p>
<p class="image-center"><img alt="" src="images/P12-2.jpg"/></p>
<h2 class="subhead1">Plaiting</h2>
<p class="noindent">Plaiting is the interlacing of three cords or groups of cords to create a braid. Cross the left-hand cord over the centre cord to become the centre cord. Then cross the right-hand cord over the new centre cord so that it now takes the centre position. Continue to alternate left- and right-hand cords to the centre position to form the braid.</p>
<h2 class="subhead1">Numbering Cords</h2>
<p class="noindent">This is a way of counting cords to find the exact section to begin working from in a macramé pattern. Cords are counted from left to right, usually mentally for smaller projects where fewer cords are used.</p>
<p class="noindent">When working on large projects that use many cords to create the pattern, it is easy to lose count. To help you to keep track, you can temporarily tie a piece of bright yarn around every tenth cord, or you can use pegs to keep groups of cords together.</p>
<h2 class="subhead1">Joining Weaving Cords</h2>
<p class="noindent">To create a thicker textured yarn, lay cord ends of equal lengths together and use tape to secure them.</p>
<p class="image-center"><img alt="" src="images/P13-1.jpg"/></p>
<h2 class="subhead1">Adding Weaving Cords</h2>
<p class="noindent">This technique enables you to add more yarn if you have run out or if you want to change the type of yarn you are weaving with. Simply add in the new thread next to the previously worked thread, keeping the over and under pattern.</p>
<p class="image-center"><img alt="" src="images/P13-2.jpg"/></p>
<h2 class="subhead1">Weaving Finishing Technique</h2>
<h3 class="subhead2">For Macramé Knots</h3>
<p class="noindent">Bring the cord ends to the back of the design and pass them underneath the loop of one or more knots.</p>
<p class="image-center"><img alt="" src="images/P13-3.jpg"/></p>
<h3 class="subhead2">For Weft Threads</h3>
<p class="noindent">Bring loose weft ends at the side or the front of the woven area to the back. Use a needle or your hands to weave in all ends, so they can’t be seen at the front.</p>
<p class="image-center"><img alt="" src="images/P13-4.jpg"/></p>
<div class="box">
<h2 class="box-head1">Lacing Up</h2>
<p class="box-text1">The sides of the pocket on the clutch purse are laced together by threading the holding cord through the spaces in the alternating square knot patterns.</p>
<p class="image-center"><img alt="" src="images/P13-5.jpg"/></p>
<h2 class="box-head1">Whip Stitch</h2>
<p class="box-text1">This is a basic stitch that is used to secure two layers of material together. Be sure to work through both layers and aim to keep your stitches uniform.</p>
<p class="image-center"><img alt="" src="images/P13-6.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter3.vue?603b02fb